module.exports = __webpack_public_path__ + "static/defaultBlogPost1-56249d60d9431fe69d90e48ccac69d46.jpg";